import { Typography } from "antd";

import { formatSecondsToCompactDuration } from "@regal-voice/ui";

import { MetricBreakdownGrid } from "../AdvancedTotals/Charts/MetricBreakdownGrid";

import type { MetricBreakdownItem } from "../../../utils";

type DisplayProps = {
    loading: boolean;
    activityBreakdown?: Array<{ activityName: string; duration: number }>;
};

export function timeInStatusItems(
    activityBreakdown?: Array<{ activityName: string; duration: number }>
): MetricBreakdownItem[] {
    return (activityBreakdown || [])
        .filter(({ duration }) => duration > 0)
        .map(({ activityName, duration }) => ({
            label: activityName,
            value: formatSecondsToCompactDuration(duration),
        }));
}

export const TimeInStatusDisplay = ({ loading, activityBreakdown }: DisplayProps): JSX.Element => {
    const items = timeInStatusItems(activityBreakdown);

    if (!loading && items.length === 0) {
        return <Typography.Text>No activity data available for today.</Typography.Text>;
    }

    return <MetricBreakdownGrid loading={loading} items={items} title="Time in Status" testId="time-in-status" />;
};
